// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"2008f2c2","46":"f0c97b0b","130":"df307c4f","163":"efb1c9fc","223":"072971bc","375":"d35143bc","423":"a62c4b10","455":"89d33f27","488":"328ec08b","575":"fa352eb9","596":"ddd09194","768":"3694e4d0","977":"e05582e0"}[chunkId] + ".chunk.js";
};